/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.progress.ProgressKind
*/
export var ProgressKind;
(function (ProgressKind) {
    ProgressKind["METRICS"] = "METRICS";
    ProgressKind["PLAN"] = "PLAN";
    ProgressKind["STATUS"] = "STATUS";
    ProgressKind["REPLY"] = "REPLY";
})(ProgressKind || (ProgressKind = {}));
//# sourceMappingURL=ProgressKind.js.map